if ( !window.adobeDataLayer ) {
    window.adobeDataLayer=[];
}

export function processComponent(componentData ) {
    const dataLayerValue = componentData.getAttribute( 'data-cmp-data-layer' );

    if ( dataLayerValue ) {
        const dataLayerObject = JSON.parse( dataLayerValue );
        const id = Object.keys( dataLayerObject )[ 0 ];
        const type = dataLayerObject[ id ][ '@type' ];

        const links = componentData.querySelectorAll( 'a' );
        links.forEach( ( link, index ) => processLink( link, id, type, index ) );
    }
}

function processLink( link, id, type, index ) {
    const linkTitle = link.textContent.split( '(' )[ 0 ];
    const modifiedId = id + "-cta-" + index;
    const modifiedType = type;
    const linkUrl = link.href;

    const linkDataLayerObj = {
        [ modifiedId ]: {
            '@type': modifiedType,
            'dc:title': linkTitle,
            'parentComponentName': id.split("-")[0],
            'parentId': id,
            'xdm:linkURL': linkUrl
        }
    };

    link.addEventListener( 'click', ( event ) => handleLinkClick( event, modifiedId ) );

    window.adobeDataLayer.push({
        component: linkDataLayerObj
    });
}

function handleLinkClick( event, modifiedId ) {
    window.adobeDataLayer.push({
        event: 'cmp:click',
        eventInfo: {
            path: 'component.' + modifiedId
        }
    });
}

const getClosestParentComponentId = ( element, attribute ) => {
    const componentElement = element.closest( "[" + attribute + "]" );

    if ( !componentElement ) {
        return;
    }

    return Object.keys( JSON.parse( componentElement.getAttribute( attribute ) ) )[ 0 ];
};

export const addCustomEventDataLayer = ( element, eventName, customEventInfoParams ) => {
    //added root container condition for BlockIT pages
    const dataLayerEnabled = document.body.hasAttribute( "data-cmp-data-layer-enabled" );
    if ( dataLayerEnabled && window.adobeDataLayer ) {
        window.adobeDataLayer.push({
            event: eventName,
            eventInfo: {
                path: "component." + getClickId( element ),
                ...customEventInfoParams
            }
        });
    }
};

export const getClickId = ( element ) => {
    const attribute =  "data-cmp-data-layer";

    if ( element.getAttribute( attribute ) ) {
        return Object.keys( JSON.parse( element.getAttribute( attribute ) ) )[ 0 ];
    }
    const closestParentComponentId = getClosestParentComponentId( element, attribute );

    if ( closestParentComponentId ) {
        return closestParentComponentId;
    }

    return getClosestParentComponentId( element, "data-cmp-data-layer" );
};